export default (id) => location.hash.substring(1) === id;
